import styled from 'styled-components';

export const prefixCls = 'ui-empty';

export const emptyClasses = {
  illustration: `${prefixCls}-illustration`,
  title: `${prefixCls}-title`,
  description: `${prefixCls}-description`,
  footer: `${prefixCls}-description`,
} as const;

export const EmptySC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .${emptyClasses.title} {
    margin-top: ${({ theme }) => theme.spacings.text.M}px;
    color: ${({ theme }) => theme.color.tint.primary};
    text-align: center;
    ${({ theme }) => theme.mappedTypography.h4.strong};
  }

  .${emptyClasses.description} {
    margin-top: ${({ theme }) => theme.spacings.text.XXS}px;
    color: ${({ theme }) => theme.color.tint.secondary};
    ${({ theme }) => theme.mappedTypography.body2.default};
  }

  .${emptyClasses.footer} {
    margin-top: ${({ theme }) => theme.spacings.text.XS}px;
  }
`;
